import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { addAnswer, clearAnsweres } from "../../../../redux/survey/actions";
import { toast } from "react-toastify";
import { withStyles } from "@mui/styles";
import { Tooltip } from "@mui/material";
import { useIntl } from "react-intl";
import { filterVisibleSurveyQuestions } from "../../../../Survey/helpers/surveyHelper";

const RatingType = (props) => {
  const intl = useIntl();
  // Destructuring props
  const {
    finishSurvey,
    headTonext,
    question,
    answeres,
    addAnswer_,
    survey_theme,
    onSend,
    clearAnsweres_,
    allQuestionsOriginal,
    setAllQuestions,
    surveyType,
    currentQuestionIndex,
    hideQuestion,
    allQuestions,
    edit_answer,
  } = props;

  // State variables
  const [checked, setChecked] = useState("");
  // State to control the tooltip
  const [openTooltip, setOpenTooltip] = useState(null);

  const handleRating = (
    ratingId,
    value,
    text,
    routeToIndex,
    hideIndex,
    score_exclude,
    finishedSurvey
  ) => {
    setChecked(ratingId);
    // Check if the survey type is "tablet" and it's the first question
    if (surveyType === "tablet" && currentQuestionIndex === 0) {
      // Clear answers if it's the first question on a tablet survey
      clearAnsweres_();
      // Calculate the percentage based on the current question's value and max score
      const percentage = (Number(value) / Number(question?.maxScore)) * 100;
      // Filter questions based on percentage for positive or neutral journey type
      if (percentage >= 70) {
        // Filter questions excluding the current question and those with negative journey type
        const filteredQuestion = filterVisibleSurveyQuestions(
          allQuestionsOriginal
            .filter((item) => item._id !== question._id)
            .filter(
              (item) =>
                item.journey_type === "neutral" ||
                item.journey_type === "positive"
            )
        );

        setAllQuestions([question, ...filteredQuestion]);
      } else {
        // Filter questions excluding the current question and those with positive journey type
        const filteredQuestion = filterVisibleSurveyQuestions(
          allQuestionsOriginal
            .filter((item) => item._id !== question._id)
            .filter(
              (item) =>
                item.journey_type === "neutral" ||
                item.journey_type === "negative"
            )
        );

        setAllQuestions([question, ...filteredQuestion]);
      }
    }
    // call hideQuestion if not finishing the survey and hide index is provided
    if (!finishSurvey && hideIndex?.length) {
      hideQuestion(hideIndex);
    }
    addAnswer_({
      id: question._id,
      value: ratingId,
      type: "id",
      score_exclude: score_exclude,
    });
    // Open the tooltip for the clicked emoji
    setOpenTooltip(ratingId);
    // Show an error toast if the question is required and no rating is selected
    if (question?.required && !ratingId) {
      toast.error(intl.formatMessage({ id: "this-question-is-required" }));
      return;
    } else {
      // Navigate to the next question if the selected option has a route_to_index
      if (!finishedSurvey && routeToIndex) {
        headTonext(routeToIndex, question._id);
      }
      // Finish the survey if the selected option has the finish_survey flag set to true
      if (finishedSurvey) {
        finishSurvey(finishedSurvey, question);
      }
      // Finish the survey if the current question is the last question
      const isNotEditing =
        !edit_answer || Object?.keys(edit_answer)?.length === 0;
      if (currentQuestionIndex + 1 >= allQuestions?.length && isNotEditing) {
        finishSurvey(true, question);
      }
      // Send the selected option's text as an answer
      onSend(text);
    }
  };

  const handleTooltipClose = () => {
    setOpenTooltip(null);
  };

  // Skip the current question and finish the survey if it's the last question
  const onSkipQuestion = () => {
    onSend("");
    const isNotEditing =
      !edit_answer || Object?.keys(edit_answer)?.length === 0;
    if (currentQuestionIndex + 1 >= allQuestions?.length && isNotEditing) {
      finishSurvey(true, question);
    }
  };

  const CustomTooltip = withStyles({
    tooltip: {
      color: "white",
      backgroundColor: survey_theme?.primaryColor,
      fontSize: "0.8rem",
      top: "0.7rem",
    },
    arrow: {
      color: survey_theme?.primaryColor,
    },
  })(Tooltip);

  // Function to load data from Redux store when component mounts
  const loadData = () => {
    if (question._id in answeres) {
      setChecked(answeres[question._id]?.value);
    }
  };

  useEffect(() => {
    loadData();
  }, [answeres]);

  return (
    <>
      <div className="px-2 bg-white border-t border-gray-200">
        <div className="pt-2 px-2 d-flex justify-content-between">
          <div className="rate-btn p-1">
            <div className="row col-12 pr-0" style={{ gap: "8px" }}>
              {question?.options.map((item, index) => (
                <CustomTooltip
                  title={item?.optionText || ""}
                  placement="top"
                  open={openTooltip === item._id}
                  onClose={() => handleTooltipClose()}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                  arrow
                >
                  <div
                    key={index}
                    className="col-1"
                    style={{
                      border: "1px solid #404040",
                      borderRadius: "5px",
                      minHeight: "35px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      backgroundColor:
                        checked === item._id ? "#e8e8e8" : "white",
                      color: "#000",
                    }}
                    onClick={() => {
                      handleRating(
                        item._id,
                        item.value,
                        item.text,
                        item?.route_to_index,
                        item?.hide_questions,
                        item?.score_exclusion_selection,
                        item?.finish_survey === true
                      );
                    }}
                  >
                    {item.text}
                  </div>
                </CustomTooltip>
              ))}
            </div>
          </div>
          <div>
            {!question?.required ? (
              <button
                onClick={() => onSkipQuestion()}
                type="button"
                className="inline-flex items-center justify-center flex-1 px-3 py-2.5 text-sm font-medium leading-4 transition-all duration-200 bg-transparent border border-purple-600 rounded-full shadow-sm hover:bg-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-600"
              >
                {intl.formatMessage({ id: "skip" })}
              </button>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </>
  );
};
// Redux mapping function to map state to props
const mapStateToProps = (state) => {
  return {
    answeres: state.survey.answeres,
    edit_answer: state.survey.edit_answer,
  };
};
// Redux mapping function to map dispatch to props
const mapDispatchToProps = (dispatch) => {
  return {
    addAnswer_: (data) => dispatch(addAnswer(data)),
    clearAnsweres_: () => dispatch(clearAnsweres()),
  };
};
// Connects the RatingType component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(RatingType);
